import { connect } from 'react-redux';
import { checkPostalCode, onChangeClasses, onChangeInformation, onChange } from './../../../../../actions/addOrder';
import ShipToComponent from './../../../components/ship-to';
import './styles.css';

class ShipTo extends ShipToComponent {
    constructor(props) {
        super(props)
    }
}

const mapStateToProps = state => {
    return {
        classes: state.addOrder.classes,
        information: state.addOrder.information,
        order: state.addOrder
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeInformation: payload => {
            dispatch(onChangeInformation(payload))
        },
        checkPostalCode: payload => {
            dispatch(checkPostalCode(payload))
        },
        onChangeClasses: payload => {
            dispatch(onChangeClasses(payload))
        },
        onChange: payload => {
            dispatch(onChange(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShipTo)



// WEBPACK FOOTER //
// ./src/containers/orders/add/components/ship-to/index.js